import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import CaptionFont from '../../../Theme/Fonts/Caption'
import { LiveMatchProps } from '../MatchTypes'
import LiveMatchResult from '../LiveMatchResult'
import Template from '../Template'
import LiveAnimation from '../../../Animations/LiveAnimation'

const LiveMatch: FC<Omit<LiveMatchProps, 'type'>> = ({
    homeCompetitor,
    additionalField1,
    additionalField2,
    awayCompetitor,
    homeScore,
    awayScore,
    caption,
    minify,
    onPressMatch,
    matchHref,
    onPressMore,
    progressPercent,
    testID,
    isSingleMatch,
    centerComponentWidth,
    betProps,
    paddingTop,
    borderRadius,
    forceMobileView,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText = 'Livestream',
}) => {
    return (
        <Template
            additionalField1={additionalField1}
            additionalField2={additionalField2}
            awayCompetitor={awayCompetitor}
            center={
                <LiveMatchResult
                    homeScore={homeScore}
                    awayScore={awayScore}
                    progressPercent={progressPercent}
                />
            }
            minify={!caption || minify}
            isSingleMatch={isSingleMatch}
            homeCompetitor={homeCompetitor}
            onPressMatch={onPressMatch}
            matchHref={matchHref}
            onPressVideoButton={onPressVideoButton}
            videoButtonHref={videoButtonHref}
            videoButtonText={videoButtonText}
            onPressMore={onPressMore}
            centerComponentWidth={centerComponentWidth}
            prefix={
                <Grid
                    noExpand
                    horizontal
                    height={20}
                    centerVertical
                    width={!caption || minify ? 12 : 28}
                >
                    {caption && !minify ? (
                        <Grid paddingLeft={1} minWidth={0}>
                            <CaptionFont color="ORANGE" numberOfLines={1}>
                                {caption}
                            </CaptionFont>
                        </Grid>
                    ) : (
                        <Grid paddingBottom="0.5px" noExpand>
                            <LiveAnimation />
                        </Grid>
                    )}
                </Grid>
            }
            testID={testID}
            betProps={betProps}
            paddingTop={paddingTop}
            borderRadius={borderRadius}
            forceMobileView={forceMobileView}
        />
    )
}

export default LiveMatch
